export default __webpack_public_path__ + "static/KV_AD_9734_rgb-db66095ba409840618f5c3a06deed648.jpg";